import {Payload} from '../../../../../../core/service/payload/payload';
import {Moment} from 'moment';
import {SaleCreateSimplePaymentCheckPayload} from './saleCreateSimplePaymentCheck.payload';
import {AccountingMovementCheckPayload} from '../../../../../../accounting/movement/api/entity/accountingMovement.model';

export class SaleCreateSimplePaymentPayload implements Payload {

    accountId: string;
    paymentTypeValue: string;
    check: AccountingMovementCheckPayload;
    date: Moment;
}
